import HistoryDetails from "./HistoryDetails";


export default function HistoryTab() {

    return <>
        <HistoryDetails />
    </>
}